import {observer} from "mobx-react-lite";
import React from "react";
import {Route, Redirect} from "react-router-dom";
import {RoutePaths} from "../../shared/routePaths";
import {useStores} from "../../stores/useStores";

const ProtectedRoute = ({
  component: Component,
  subject,
  permissions,
  isAccessibleWithoutASelectedVillage = true,
  ...rest
}: any) => {
  const {
    uiStore,
    uiStore: {accountStore}
  } = useStores();

  const canAccessFeature = (): boolean => {
    if (!subject || !permissions) {
      return true;
    }
    for (let i = 0; i < permissions.length; i++) {
      // If a route is not accessible without a selected village, redirect it to the default page.
      if (
        accountStore.abilities.can(permissions[i], subject) &&
        (isAccessibleWithoutASelectedVillage ||
          uiStore.selectableVillages.selectedItem?.value)
      ) {
        return true;
      }
    }
    return false;
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        if (accountStore.isAuthenticated) {
          if (accountStore.isAuthorised && canAccessFeature()) {
            return <Component {...props} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: RoutePaths.AccessDenied,
                  state: {from: props.location}
                }}
              />
            );
          }
        }
        return (
          <Redirect
            to={{
              pathname: RoutePaths.SignIn,
              state: {from: props.location}
            }}
          />
        );
      }}
    />
  );
};

export default observer(ProtectedRoute);
